let lastScrollY = window.scrollY;

document.addEventListener("DOMContentLoaded", function () {
  function calculateStickyTop() {
    const pfasWarning = document.querySelector(".pfas__cart-item");
    const baseTop = 0;

    if (pfasWarning) {
      const pfasHeight = pfasWarning.offsetHeight;
      return baseTop + pfasHeight;
    }
    return baseTop;
  }

  function updatePfasSticky() {
    const pfasWarning = document.querySelector(".pfas__cart-item");
    if (pfasWarning) {
      pfasWarning.style.position = "sticky";
      pfasWarning.style.zIndex = "11";
      pfasWarning.style.transition = "top 0.15s";

      const isMobile = window.innerWidth < 990;
      const isTablet = window.innerWidth >= 990 && window.innerWidth < 1200;
      const isDesktop = window.innerWidth >= 1200;

      if (window.scrollY < lastScrollY && window.scrollY > 0) {
        if (isMobile) {
          pfasWarning.style.top = "136px";
        } else if (isTablet) {
          pfasWarning.style.top = "138px";
        } else {
          pfasWarning.style.top = "65px";
        }
      } else {
        pfasWarning.style.top = "0px";
      }
    }
  }
  function updateCartHeadingPosition() {
    const cartHeading = document.querySelector(
      ".cart-items_heading:not(.mobile)"
    );
    const cartHeadingMobile = document.querySelector(
      ".cart-items_heading.mobile"
    );

    const pfasWarning = document.querySelector(".pfas__cart-item");
    const hasPfas = pfasWarning !== null;

    const isMobile = window.innerWidth < 576;
    const isTablet = window.innerWidth >= 990 && window.innerWidth < 1200;
    const isDesktop = window.innerWidth >= 1200;

    // Handle desktop/tablet heading
    if (cartHeading) {
      cartHeading.style.transition = "top 0.15s";

      if (window.scrollY === 0) {
        const dynamicTop = calculateStickyTop();
        cartHeading.style.top = `${dynamicTop}px`;
      } else if (window.scrollY < lastScrollY && window.scrollY > 0) {
        if (hasPfas) {
          if (isTablet) {
            cartHeading.style.top = "193px";
          } else {
            cartHeading.style.top = "110px";
          }
        } else {
          if (isTablet) {
            cartHeading.style.top = "138px";
          } else {
            cartHeading.style.top = "65px";
          }
        }
      } else {
        const dynamicTop = calculateStickyTop();
        // Apply -2px adjustment for desktop when scrolling down with PFAS items
        if (hasPfas && isDesktop) {
          cartHeading.style.top = `${dynamicTop - 2}px`;
        } else {
          cartHeading.style.top = `${dynamicTop}px`;
        }
      }
    }

    // Handle mobile heading
    if (cartHeadingMobile && isMobile) {
      cartHeadingMobile.style.transition = "top 0.15s";

      if (window.scrollY === 0) {
        const dynamicTop = calculateStickyTop();
        cartHeadingMobile.style.top = `${dynamicTop}px`;
      } else if (window.scrollY < lastScrollY && window.scrollY > 0) {
        if (hasPfas) {
          if (window.innerWidth >= 445 && window.innerWidth <= 576) {
            cartHeadingMobile.style.top = "195px";
          } else if (window.innerWidth < 460) {
            cartHeadingMobile.style.top = "210px";
          } else {
            cartHeadingMobile.style.top = "145px";
          }
        } else {
          cartHeadingMobile.style.top = "135px";
        }
      } else {
        const dynamicTop = calculateStickyTop();
        cartHeadingMobile.style.top = `${dynamicTop}px`;
      }
    }
  }

  updatePfasSticky();
  updateCartHeadingPosition();

  window.addEventListener("scroll", function () {
    updatePfasSticky();
    updateCartHeadingPosition();
    lastScrollY = window.scrollY;
  });

  window.addEventListener("resize", function () {
    updatePfasSticky();
    updateCartHeadingPosition();
  });

  // Helper to lock cart heading position
  function lockCartHeading() {
    const cartHeading = document.querySelector(
      ".cart-items_heading:not(.mobile)"
    );
    const cartHeadingMobile = document.querySelector(
      ".cart-items_heading.mobile"
    );

    const pfasWarning = document.querySelector(".pfas__cart-item");
    const hasPfas = pfasWarning !== null;
    const isMobile = window.innerWidth < 576;
    const isTablet = window.innerWidth >= 990 && window.innerWidth < 1200;
    const isDesktop = window.innerWidth >= 1200;

    let topValue = "0px";

    // Calculate top value based on current state
    if (window.scrollY === 0) {
      topValue = calculateStickyTop() + "px";
    } else if (window.scrollY < lastScrollY && window.scrollY > 0) {
      if (hasPfas) {
        if (isMobile) topValue = "145px";
        else if (isTablet) topValue = "193px";
        else topValue = "110px";
      } else {
        if (isMobile) topValue = "65px";
        else if (isTablet) topValue = "138px";
        else topValue = "65px";
      }
    } else {
      const dynamicTop = calculateStickyTop();
      // Apply -2px adjustment for desktop when scrolling down with PFAS items
      if (hasPfas && isDesktop) {
        topValue = dynamicTop - 2 + "px";
      } else {
        topValue = dynamicTop + "px";
      }
    }

    // Lock desktop heading
    if (cartHeading) {
      cartHeading.classList.add("cart-heading-lock");
      cartHeading.style.setProperty("top", topValue, "important");
    }

    // Lock mobile heading
    if (cartHeadingMobile && isMobile) {
      cartHeadingMobile.classList.add("cart-heading-lock");
      cartHeadingMobile.style.setProperty("top", topValue, "important");
    }
  }

  function unlockCartHeading() {
    const cartHeading = document.querySelector(
      ".cart-items_heading:not(.mobile)"
    );
    const cartHeadingMobile = document.querySelector(
      ".cart-items_heading.mobile"
    );

    // Unlock desktop heading
    if (cartHeading) {
      cartHeading.classList.remove("cart-heading-lock");
      cartHeading.style.removeProperty("top");
    }

    // Unlock mobile heading
    if (cartHeadingMobile) {
      cartHeadingMobile.classList.remove("cart-heading-lock");
      cartHeadingMobile.style.removeProperty("top");
    }

    updateCartHeadingPosition();
  }

  const cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        // Lock heading before update
        lockCartHeading();
        // After DOM update, unlock and recalc
        setTimeout(() => {
          updatePfasSticky();
          unlockCartHeading();
        }, 100);
      }
    });
  });

  const cartItems = document.querySelector("#main-cart-items");
  if (cartItems) {
    cartObserver.observe(cartItems, {
      childList: true,
      subtree: true,
    });
  }
});
